import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { IntroducingEazyBot } from "@/components/landing/IntroducingEazyBot";
import { Pillars } from "@/components/landing/Pillars";
import { ProvenPerformance } from "@/components/landing/ProvenPerformance";
import HowItWorks from "@/components/landing/HowItWorks";
import { CTASection } from "@/components/landing/CTASection";
import { Footer } from "@/components/landing/Footer";
import GetStartedPage from "@/components/landing/GetStartedPage";

function HomePage() {
  return (
    <div
      className="App min-h-screen text-white"
      style={{ background: "#141034" }}
      data-testid="app-root"
    >
      <Header />
      <main>
        <Hero />
        <IntroducingEazyBot />
        {/* Thin soft separator: dark navy → light periwinkle */}
        <div style={{ height: 2, background: "linear-gradient(90deg, transparent, rgba(160,170,210,0.5), transparent)" }} aria-hidden="true" />
        <Pillars />
        {/* Thin soft separator: light periwinkle → dark */}
        <div style={{ height: 2, background: "linear-gradient(90deg, transparent, rgba(160,170,210,0.5), transparent)" }} aria-hidden="true" />
        <ProvenPerformance />
        <HowItWorks />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/get-started" element={<GetStartedPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
